import firebase from 'firebase'
import axios from 'axios'
import { 
  influencerCreateContentNoteApi,
  influencerUpdateContentNoteApi,
  influencerGetAllContentNoteApi
} from "@/config/appSettings"

// Create content note
export const createContentNote = async (data) => {
  try {
    const response = await axios.post(`${influencerCreateContentNoteApi}`, JSON.stringify(data))
    return response
  } catch (error) {
    return error
  }
}

// Update content note
export const updateContentNote = async (data) => {
  try {
    const response = await axios.post(`${influencerUpdateContentNoteApi}`, JSON.stringify(data))
    return response
  } catch (error) {
    return error
  }
}

// Get list of Notes by content id
export const getContentNoteList = async (contentId) => {
  try {    
    const response = await axios.get(`${influencerGetAllContentNoteApi}/?usertoken=${firebase.auth().currentUser.uid}&content=${contentId}`)
    return response
  } catch (error) {
    return error
  }
}